<template>
  <div>
    <h4 class="title has-text-centered is-4">Search</h4>

    <form @submit="handleSubmit">
      <b-field grouped>
        <b-field label="Furniture ID" custom-class="is-small">
          <b-input v-model="formData.furniture_id" size="is-small"></b-input>
        </b-field>

        <b-field label="Buyer User ID" custom-class="is-small">
          <b-input v-model="formData.buyer_id" size="is-small"></b-input>
        </b-field>

        <b-field label="Min Date" custom-class="is-small">
          <b-input v-model="formData.min_date" size="is-small"></b-input>
        </b-field>

        <b-field label="Max Date" custom-class="is-small">
          <b-input v-model="formData.max_date" size="is-small"></b-input>
        </b-field>
      </b-field>

      <b-field grouped>
        <b-field label="Currency" custom-class="is-small">
          <b-select v-model="formData.price_type" size="is-small">
            <option value="monetti">Monetti</option>
            <option value="currants">Currants</option>
          </b-select>
        </b-field>

        <b-field label="Min Price" custom-class="is-small">
          <b-input v-model="formData.min_price" size="is-small"></b-input>
        </b-field>

        <b-field label="Max Price" custom-class="is-small">
          <b-input v-model="formData.max_price" size="is-small"></b-input>
        </b-field>
      </b-field>

      <b-button type="is-info" icon-left="search" native-type="submit" size="is-small">Search</b-button>
    </form>

  </div>
</template>

<script>
export default {
  name: 'furniture-sales-search-form',
  data() {
    return {
      errors: [],
      formData: {
        price_type: 'monetti',
        ...this.$route.query,
      },
      loadingForm: false,
      sent: false,
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();

      this.errors = [];
      this.loadingForm = true;

      const params = {
        ...this.formData,
        page: 1,
      };

      const queryString = Object.keys(params).map((key) => `${key}=${params[key] || ''}`).join('&');

      this.$router.push({ path: `/furniture-sales?${queryString}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
